import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setTrainProgressData } = slice.actions;

const getTrainProgress = (url: any) => async () => {
  try {
    const response = await API.trainProgress.getTrainProgress(url);
    dispatch(setTrainProgressData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error) {}
};

export default {
  getTrainProgress
};
